import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function GalleryViewer() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true); // ✅ added

  const API = process.env.PARCEL_API_URL;

  useEffect(() => {
    if (!API) return;

    axios.get(`${API}/api/gallery`)
      .then(res => {
        const data = res.data || [];
        setImages(data);

        const index = data.findIndex(img => img._id === id);
        setCurrent(index !== -1 ? index : 0);
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false)); // ✅ important
  }, [API, id]);

  const next = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prev = () => {
    setCurrent((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  // 🔥 FULLSCREEN SKELETON
  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-95 flex items-center justify-center z-50">
        <div className="w-[90vw] max-w-4xl h-[60vh] bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
    );
  }

  if (!images.length) {
    return (
      <p className="text-center mt-10 text-gray-500">
        No images found
      </p>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-95 flex flex-col items-center justify-center z-50">

      {/* ❌ CLOSE */}
      <button
        onClick={() => navigate("/gallery")}
        className="absolute top-5 right-5 text-white text-4xl hover:scale-110 transition"
      >
        ✕
      </button>

      {/* 🖼 IMAGE */}
      {images[current] && (
        <img
          src={images[current].image || images[current].imageUrl}
          className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-xl transition duration-300"
        />
      )}

      {/* 🔁 CONTROLS */}
      <div className="flex items-center gap-6 mt-6">

        <button
          onClick={prev}
          className="bg-white px-4 py-2 rounded shadow hover:scale-110 transition"
        >
          ←
        </button>

        <span className="text-white text-lg">
          {current + 1} / {images.length}
        </span>

        <button
          onClick={next}
          className="bg-white px-4 py-2 rounded shadow hover:scale-110 transition"
        >
          →
        </button>

      </div>

    </div>
  );
}